/* DARKFIT theme behaviour. No dependencies. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DF = window.DF || { routes: {}, strings: {} };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function onScroll(fn) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; fn(); });
    }, { passive: true });
    window.addEventListener('resize', fn, { passive: true });
    fn();
  }

  /* Toast (status messages instead of alert()) */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t || !msg) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* Overlay helpers: scroll lock + focus in/out */
  var lastFocus = null;
  function openOverlay(el, focusSel) {
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var f = $(focusSel || 'button, a, input, select', el); if (f) f.focus({ preventScroll: true });
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function trapTab(e, el) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea', el).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* Header: transparent over the home hero, solid after 75% of the viewport */
  function initHeader() {
    var header = $('[data-header]');
    var first = $('main') && $('main').firstElementChild;
    var topHero = first && first.querySelector('[data-hero]:not(.df-hero--inline), [data-hero-top]');
    if (!header || !document.body.classList.contains('df-home') || !topHero) { if (header) header.classList.remove('is-clear'); return; }
    onScroll(function () { header.classList.toggle('is-clear', window.scrollY < window.innerHeight * 0.75); });
  }

  /* Hero: hover/focus expands a half (desktop); mobile crossfades open/zipped every 3.6s until a tab is tapped */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      $$('.df-hero__half', hero).forEach(function (half) {
        var side = half.classList.contains('df-hero__half--l') ? 'l' : 'r';
        function on() { hero.dataset.hover = side; }
        function off() { delete hero.dataset.hover; }
        half.addEventListener('mouseenter', on); half.addEventListener('focus', on);
        half.addEventListener('mouseleave', off); half.addEventListener('blur', off);
      });
      var imgs = $$('.df-hero__mobile img[data-state]', hero), tabs = $$('.df-hero__tabs [data-state]', hero), pinned = false;
      function show(state) {
        imgs.forEach(function (i) { i.classList.toggle('is-active', i.dataset.state === state); });
        tabs.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.state === state ? 'true' : 'false'); });
      }
      tabs.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); pinned = true; show(b.dataset.state); }); });
      if (imgs.length > 1 && !RM) {
        var timer = setInterval(function () {
          if (pinned) { clearInterval(timer); return; }
          if (window.innerWidth >= 1100 || document.hidden) return;
          var cur = (imgs.filter(function (i) { return i.classList.contains('is-active'); })[0] || imgs[0]).dataset.state;
          show(cur === 'open' ? 'zip' : 'open');
        }, 3600);
      }
    });
  }

  /* The object: a spec becomes active when its top passes 55% of the viewport; the sticky image follows */
  function initSpecs() {
    $$('[data-specs]').forEach(function (root) {
      var specs = $$('[data-spec]', root); if (!specs.length) return;
      var imgs = $$('[data-spec-img]', root), counter = $('[data-spec-counter]', root);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      var last = -1;
      onScroll(function () {
        var a = 0, vh = window.innerHeight;
        specs.forEach(function (el, i) { if (el.getBoundingClientRect().top < vh * 0.55) a = i; });
        if (a === last) return; last = a;
        specs.forEach(function (el, i) { el.classList.toggle('is-active', i === a); });
        imgs.forEach(function (el) { el.classList.toggle('is-active', Number(el.dataset.specImg) === a); });
        if (counter) counter.textContent = pad(a + 1) + ' / ' + pad(specs.length);
      });
    });
  }

  /* Manifesto: words fill in as the block scrolls: progress = (vh*.85 − top) / (height*.55) */
  function initManifesto() {
    $$('[data-manifesto]').forEach(function (box) {
      var words = $$('.df-words span', box);
      if (RM) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      onScroll(function () {
        var r = box.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height * 0.55)));
        words.forEach(function (w, i) { w.classList.toggle('is-on', i / words.length < p); });
      });
    });
  }

  /* Cart: AJAX add/change, re-render the cart-drawer section via the Section Rendering API */
  function drawerEl() { return $('[data-cart-drawer]'); }
  function openDrawer() { var d = drawerEl(); if (d) openOverlay(d, '[data-close-cart]'); }
  function closeDrawer() { closeOverlay(drawerEl()); }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-cart-drawer]', tmp), old = drawerEl();
    if (fresh && old) {
      // keep the shopper's place in the bag (e.g. while adding from "Browse all pieces")
      var oldLines = $('.df-drawer__lines', old), keepTop = oldLines ? oldLines.scrollTop : 0;
      var open = old.classList.contains('is-open');
      old.replaceWith(fresh);
      initDrawerBrowse();
      var newLines = $('.df-drawer__lines', fresh); if (newLines && dbState.open) newLines.scrollTop = keepTop;
      if (open) { fresh.classList.add('is-open'); if (!dbState.open) { var c = $('[data-close-cart]', fresh); if (c) c.focus({ preventScroll: true }); } }
    }
  }
  function cartPost(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function refreshCount() {
    return fetch(DF.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function addToCart(id, qty, btn) {
    var isMain = btn && btn.hasAttribute('data-add-label'), label = btn ? btn.textContent : '';
    if (btn) { btn.classList.add(isMain ? 'is-loading' : 'is-busy'); if (isMain) btn.textContent = DF.strings.adding; }
    return cartPost(DF.routes.cart_add, { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function (j) { renderDrawer(j.sections && j.sections['cart-drawer']); return refreshCount(); })
      .then(function () {
        if (isMain) { btn.textContent = DF.strings.added; btn.classList.add('is-done'); setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); }, 1800); }
        openDrawer();
      })
      .catch(function (e) { if (isMain) btn.textContent = label; toast((e && (e.description || e.message)) || DF.strings.error); })
      .then(function () { if (btn) btn.classList.remove('is-busy', 'is-loading'); });
  }
  /* "Browse all pieces" in the bag: any product, colour and size, without leaving the bag */
  var dbState = { open: false, q: '', cat: '', scroll: 0, colours: {} };
  function initDrawerBrowse() {
    var root = $('[data-cart-drawer] [data-dbrowse]'); if (!root) return;
    var toggle = $('[data-dbrowse-toggle]', root), panel = $('[data-dbrowse-panel]', root), list = $('[data-dbrowse-list]', root);
    var qIn = $('[data-dbrowse-q]', root), chips = $('[data-dbrowse-chips]', root), colourPick = dbState.colours;
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function pieces(all) {
      // Several admin listings are the same piece in another colour: show each piece once (the one with most stock)
      var by = {};
      all.forEach(function (p) {
        var k = cleanTitle(p.title).toLowerCase(), a = p.variants.filter(function (v) { return v.available; }).length;
        if (!by[k]) by[k] = { p: p, a: a, group: [] };
        by[k].group.push(p);
        if (a > by[k].a) { by[k].p = p; by[k].a = a; }
      });
      return Object.keys(by).map(function (k) { var x = by[k]; x.p._group = x.group; return x.p; });
    }
    function row(p) {
      var group = p._group || [p];
      function idx(x, re) { return x.options.findIndex(function (n) { return re.test(n); }); }
      function hasColour(x, c) { var i = idx(x, COLOUR_RE); return i > -1 && x.variants.some(function (v) { return v.options[i] === c && v.available; }); }
      function named(x, c) { var t = x.title.toLowerCase().replace(/[^a-z]/g, ''), k = c.toLowerCase().replace(/[^a-z]/g, ''); return k && t.slice(-k.length - 2).indexOf(k) > -1; }
      // Colours across every listing of this piece; each colour uses the listing named after it when there is one
      var colours = [];
      group.forEach(function (x) { var i = idx(x, COLOUR_RE); if (i < 0) return; x.variants.forEach(function (v) { if (v.available && colours.indexOf(v.options[i]) === -1) colours.push(v.options[i]); }); });
      var colour = colours.indexOf(colourPick[p.handle]) > -1 ? colourPick[p.handle] : colours[0];
      var src = p;
      if (colour) src = group.filter(function (x) { return named(x, colour) && hasColour(x, colour); })[0] || (hasColour(p, colour) ? p : group.filter(function (x) { return hasColour(x, colour); })[0]) || p;
      var ci = idx(src, COLOUR_RE), si = idx(src, SIZE_RE);
      var vs = src.variants.filter(function (v) { return ci < 0 || v.options[ci] === colour; });
      var price = Math.min.apply(null, vs.map(function (v) { return v.price; }));
      var ids = vs.map(function (v) { return v.id; }), vimg = (src.images || []).filter(function (im) { return im.ids.some(function (id) { return ids.indexOf(id) > -1; }); })[0];
      var img = vimg ? vimg.src : src.image, url = src.url;
      var h = '<div class="df-mini df-mini--browse">' +
        '<a class="df-media df-mini__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="150">' : '') + '</a>' +
        '<div class="df-mini__body"><div class="df-mini__top"><a class="df-mini__title" href="' + url + '">' + esc(cleanTitle(p.title)) + '</a><span class="df-mini__price">' + money(price) + '</span></div>';
      if (colours.length > 1) {
        h += '<label class="visually-hidden" for="dbc-' + p.handle + '">' + esc(src.options[ci] || 'Colour') + '</label><select class="df-dbrowse__colour" id="dbc-' + p.handle + '" data-dbrowse-colour="' + p.handle + '">' +
          colours.map(function (c) { return '<option' + (c === colour ? ' selected' : '') + '>' + esc(c) + '</option>'; }).join('') + '</select>';
      } else if (colour) { h += '<div class="df-mini__colour">' + esc(colour) + '</div>'; }
      h += '<div class="df-mini__sizes">' + vs.map(function (v) {
        var label = si > -1 ? v.options[si] : (v.options.join(' / ') || DF.strings.addBag);
        return '<button type="button" class="df-size-btn df-size-btn--xs" data-quick-add="' + v.id + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + ' aria-label="' + esc(DF.strings.addBag + ' — ' + cleanTitle(p.title) + ' / ' + v.options.join(' / ')) + '">' + esc(label) + '</button>';
      }).join('') + '</div></div></div>';
      return h;
    }
    function render() {
      loadCatalogue().then(function (all) {
        var items = pieces(all), types = [];
        items.forEach(function (p) { if (p.type && types.indexOf(p.type) === -1) types.push(p.type); });
        chips.innerHTML = [''].concat(types).map(function (t) {
          return '<button type="button" class="df-chip-btn' + (t === dbState.cat ? ' is-on' : '') + '" data-dbrowse-cat="' + esc(t) + '" aria-pressed="' + (t === dbState.cat) + '">' + esc(t || DF.strings.dbAll) + '</button>';
        }).join('');
        var q = dbState.q.toLowerCase().trim();
        var shown = items.filter(function (p) { return (!dbState.cat || p.type === dbState.cat) && (!q || (cleanTitle(p.title) + ' ' + p.type).toLowerCase().indexOf(q) > -1); });
        list.innerHTML = shown.length ? shown.map(row).join('') : '<p class="df-small df-muted">' + esc(DF.strings.noResults) + '</p>';
        list.scrollTop = dbState.scroll;
      });
    }
    function setOpen(open) {
      dbState.open = open; panel.hidden = !open; toggle.setAttribute('aria-expanded', open);
      $('[data-dbrowse-open]', toggle).hidden = open; $('[data-dbrowse-close]', toggle).hidden = !open;
      if (open) render();
    }
    toggle.addEventListener('click', function () { setOpen(!dbState.open); if (dbState.open) root.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); });
    var t; qIn.value = dbState.q;
    qIn.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { dbState.q = qIn.value; if (dbState.q) dbState.cat = ''; dbState.scroll = 0; render(); }, 150); });
    chips.addEventListener('click', function (e) { var c = e.target.closest('[data-dbrowse-cat]'); if (!c) return; dbState.cat = c.dataset.dbrowseCat; dbState.scroll = 0; render(); });
    list.addEventListener('change', function (e) { var s = e.target.closest('[data-dbrowse-colour]'); if (!s) return; colourPick[s.dataset.dbrowseColour] = s.value; render(); });
    list.addEventListener('scroll', function () { dbState.scroll = list.scrollTop; }, { passive: true });
    if (dbState.open) setOpen(true);
  }
  function addItems(items, btn) {
    var isMain = btn && btn.hasAttribute('data-add-label'), label = btn ? btn.textContent : '';
    if (btn) { btn.classList.add(isMain ? 'is-loading' : 'is-busy'); if (isMain) btn.textContent = DF.strings.adding; }
    return cartPost(DF.routes.cart_add, { items: items })
      .then(function (j) { renderDrawer(j.sections && j.sections['cart-drawer']); return refreshCount(); })
      .then(function () { if (isMain) btn.textContent = label; openDrawer(); })
      .catch(function (e) { if (isMain) btn.textContent = label; toast((e && (e.description || e.message)) || DF.strings.error); })
      .then(function () { if (btn) btn.classList.remove('is-busy', 'is-loading'); });
  }

  /* Catalogue pieces: admin listings of the same piece in other colours are merged into one piece with all colours */
  function hexFor(name) {
    var n = String(name || '').toLowerCase();
    var map = [[/black|noir|schwarz|negro/, '#0B0B0D'], [/wine|red|bordeaux|burgundy/, '#5A1722'], [/white|blanc|ivory/, '#FFFFFF'], [/grey|gray|gris|grau/, '#898B91'],
      [/rose gold/, '#C9988A'], [/olive|oliver|khaki|green|vert/, '#55603F'], [/beige|sand|cream|nude/, '#D9CBB5'], [/brown|chocolate|mocha|marron/, '#6B4A36'],
      [/pink|rose|rosa/, '#E3AFBC'], [/purple|violet|lilac|lavender/, '#6E4F86'], [/blue|navy/, '#2E3A59']];
    for (var i = 0; i < map.length; i++) if (map[i][0].test(n)) return map[i][1];
    return '#CFCFCF';
  }
  function groupPieces(all) {
    var by = {}, order = [];
    all.forEach(function (p) {
      var k = cleanTitle(p.title).toLowerCase();
      if (!by[k]) { by[k] = { key: k, title: cleanTitle(p.title), type: p.type, image: p.image, group: [] }; order.push(k); }
      by[k].group.push(p);
    });
    return order.map(function (k) {
      var pc = by[k], colours = [];
      pc.group.forEach(function (x) { var i = x.options.findIndex(function (n) { return COLOUR_RE.test(n); }); if (i < 0) return; x.variants.forEach(function (v) { if (v.available && colours.indexOf(v.options[i]) === -1) colours.push(v.options[i]); }); });
      pc.colours = colours;
      var prices = []; pc.group.forEach(function (x) { x.variants.forEach(function (v) { if (v.available) prices.push(v.price); }); });
      pc.min = Math.min.apply(null, prices); pc.max = Math.max.apply(null, prices);
      return pc;
    });
  }
  // The listing that sells this colour (the one named after it first), its colour/size option indexes and variants
  function pieceListing(pc, colour) {
    function idx(x, re) { return x.options.findIndex(function (n) { return re.test(n); }); }
    function has(x) { var i = idx(x, COLOUR_RE); return i > -1 && x.variants.some(function (v) { return v.options[i] === colour && v.available; }); }
    function named(x) { var t = x.title.toLowerCase().replace(/[^a-z]/g, ''), k = String(colour).toLowerCase().replace(/[^a-z]/g, ''); return k && t.slice(-k.length - 2).indexOf(k) > -1; }
    var src = colour ? (pc.group.filter(function (x) { return named(x) && has(x); })[0] || pc.group.filter(has)[0] || pc.group[0]) : pc.group[0];
    var ci = idx(src, COLOUR_RE), si = idx(src, SIZE_RE);
    var vs = src.variants.filter(function (v) { return ci < 0 || v.options[ci] === colour; });
    var ids = vs.map(function (v) { return v.id; }), im = (src.images || []).filter(function (m) { return m.ids.some(function (id) { return ids.indexOf(id) > -1; }); })[0];
    return { src: src, ci: ci, si: si, vs: vs, img: im ? im.src : src.image };
  }

  /* Bundle tiers on the product page (snippet df-tiers) */
  function initTiers() {
    var root = $('[data-tiers]'); if (!root) return;
    var form = root.closest('form'); if (!form) return;
    var data = JSON.parse($('[data-product-json]').textContent);
    var ci = Number(root.dataset.ci), si = Number(root.dataset.si);
    var tmain = $('[data-tmain]', root);
    var tiers = $$('[data-tier]', root), picker = $('[data-tpicker]', root), plist = $('[data-tpicker-list]', root), pq = $('[data-tpicker-q]', root);
    var slots = [], qty = 1, pickFor = -1, pieces = null;
    var addN = new RegExp('^' + DF.strings.tierAddN.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace('__N__', '\\d+') + '$');
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function checked(i) { var r = $('input[data-opt="' + i + '"]:checked', form); return r ? r.value : ''; }
    function mainVariant() {
      var colour = ci >= 0 ? checked(ci) : null, size = si >= 0 ? checked(si) : null;
      var vs = data.variants.filter(function (v) { return (ci < 0 || v.options[ci] === colour) && (si < 0 || !size || v.options[si] === size); });
      return vs.filter(function (v) { return v.available; })[0] || vs[0] || data.variants[0];
    }
    // The piece's own swatches and size boxes drive the form; only the small photos follow the colour
    var startColour = ci >= 0 ? checked(ci) : '';
    function setThumb(src) { if (src) $$('[data-tmain-img]', root).forEach(function (im) { im.removeAttribute('srcset'); im.src = src; }); }
    function syncMain() {
      var mv = mainVariant(), colour = ci >= 0 ? checked(ci) : '', media = $$('[data-media-alt]');
      var filtered = media.some(function (m) { return m.hidden; });
      if (colour && colour !== startColour && !filtered && !(mv && mv.media_id)) {
        // No photo of this colour on this listing: use the listing that sells it (the catalogue loads once, on first change)
        loadCatalogue().then(function (all) {
          pieces = pieces || groupPieces(all);
          var pc = pieces.filter(function (x) { return x.group.some(function (g) { return g.handle === data.handle; }); })[0];
          if (pc && checked(ci) === colour) setThumb(pieceListing(pc, colour).img);
        });
      } else {
        var gal = media.filter(function (m) { return !m.hidden; }).map(function (m) { return $('img', m); }).filter(Boolean)[0];
        setThumb(gal ? (gal.currentSrc || gal.src) : (mv && mv.img));
      }
      render();
    }
    function slotVariant(sl) {
      if (!sl) return null; var L = pieceListing(sl.pc, sl.colour);
      return L.vs.filter(function (v) { return (L.si > -1 ? v.options[L.si] : String(v.id)) === sl.size; })[0] || null;
    }
    function slotPrice(sl) { var v = slotVariant(sl); return v ? v.price : null; }
    // Only the pieces actually chosen count; the free pieces come off once the set is complete (as at checkout)
    function tierPrice(q, f) {
      var items = [mainVariant().price];
      for (var i = 0; i < q - 1; i++) { var sp = slotPrice(slots[i]); if (sp != null) items.push(sp); }
      var total = items.reduce(function (a, b) { return a + b; }, 0), free = 0;
      if (items.length === q) { var sorted = items.slice().sort(function (a, b) { return a - b; }); for (var k = 0; k < f; k++) free += sorted[k]; }
      return { pay: total - free, total: total };
    }
    function render() {
      var mv = mainVariant();
      tiers.forEach(function (t) {
        var q = Number(t.dataset.qty), f = Number(t.dataset.free), pr = $('[data-tprice]', t), cp = $('[data-tcompare]', t);
        if (q === 1) { pr.textContent = money(mv.price); cp.textContent = mv.compare > mv.price ? money(mv.compare) : ''; }
        else {
          var x = tierPrice(q, f), hint = $('[data-thint]', t), left = q - 1 - slots.slice(0, q - 1).filter(function (sl) { return !!slotVariant(sl); }).length;
          pr.textContent = money(x.pay); cp.textContent = x.total > x.pay ? money(x.total) : '';
          // Until the set is complete: how many pieces are still to choose and how many come free
          if (hint) hint.textContent = left > 0 ? (left === 1 ? DF.strings.tierLeft1 : DF.strings.tierLeftN.replace('__N__', left)) + ' · ' + (f === 1 ? DF.strings.tierFree1 : DF.strings.tierFreeN.replace('__N__', f)) : '';
        }
      });
      var mp = $('[data-tmain-price]', root); if (mp) mp.textContent = qty > 1 ? money(mv.price) : '';
      label();
    }
    function label() {
      $$('[data-add-label]').forEach(function (b) {
        if (qty > 1 && !b.disabled && b.textContent !== DF.strings.selectSize) b.textContent = DF.strings.tierAddN.replace('__N__', qty);
        else if (qty === 1 && addN.test(b.textContent)) b.textContent = DF.strings.addBag;
      });
    }
    function slotHTML(sl, i) {
      if (!sl) {
        return '<li class="df-tslot is-empty"><button type="button" class="df-tslot__empty" data-tchoose="' + i + '">' +
          '<span class="df-tslot__plus" aria-hidden="true">+</span>' +
          '<span class="df-tslot__body"><span class="df-tslot__n">' + esc(DF.strings.tierPieceN.replace('__N__', i + 2)) + '</span><span class="df-tslot__cta">' + esc(DF.strings.tierSelect) + '</span></span></button></li>';
      }
      var L = pieceListing(sl.pc, sl.colour), v = slotVariant(sl);
      var h = '<li class="df-tslot"><span class="df-tslot__img df-media">' + (L.img ? '<img src="' + L.img + '" alt="" width="120" height="150" loading="lazy">' : '') + '</span>' +
        '<div class="df-tslot__body"><div class="df-tslot__top"><span class="df-tslot__name">' + esc(sl.pc.title) + '</span><span class="df-tslot__price">' + (v ? money(v.price) : '') + '</span></div>';
      if (sl.pc.colours.length) {
        h += '<fieldset class="df-tslot__opt"><legend class="df-tslot__lab">' + esc(DF.strings.colour) + ' <span class="df-muted">' + esc(sl.colour) + '</span></legend><div class="df-tdots">' +
          sl.pc.colours.map(function (c) {
            return '<label class="df-tdot" title="' + esc(c) + '"><input type="radio" class="visually-hidden" name="df-ts' + i + '-c" value="' + esc(c) + '" data-tslot-colour="' + i + '"' + (c === sl.colour ? ' checked' : '') + '>' +
              '<span class="df-tdot__dot" style="--sw:' + hexFor(c) + '"></span><span class="visually-hidden">' + esc(c) + '</span></label>';
          }).join('') + '</div></fieldset>';
      }
      if (L.si > -1 || L.vs.length > 1) {
        var cur = v ? (L.si > -1 ? v.options[L.si] : v.title) : '';
        h += '<fieldset class="df-tslot__opt"><legend class="df-tslot__lab">' + esc(DF.strings.size) + ' <span class="df-muted">' + esc(cur) + '</span></legend><div class="df-tsizes">' +
          L.vs.map(function (x) {
            var lab = L.si > -1 ? x.options[L.si] : (x.options.join(' / ') || '—'), val = L.si > -1 ? x.options[L.si] : String(x.id);
            return '<label' + (x.available ? '' : ' class="is-oos"') + '><input type="radio" name="df-ts' + i + '-s" value="' + esc(val) + '" data-tslot-size="' + i + '"' + (val === sl.size ? ' checked' : '') + (x.available ? '' : ' disabled aria-label="' + esc(lab + ', ' + DF.strings.tierSoldOut) + '"') + '><span>' + esc(lab) + '</span></label>';
          }).join('') + '</div></fieldset>';
      }
      h += '<button type="button" class="df-tslot__change" data-tchoose="' + i + '">' + esc(DF.strings.tierChange) + '</button></div></li>';
      return h;
    }
    function drawSlots() {
      tiers.forEach(function (t) { var b = $('[data-tbody]', t); if (!t.classList.contains('is-on')) { b.innerHTML = ''; } });
      var on = tiers.filter(function (t) { return t.classList.contains('is-on'); })[0], body = $('[data-tbody]', on);
      if (tmain.parentNode !== body) body.appendChild(tmain);
      tmain.classList.toggle('is-set', qty > 1);
      var old = $('.df-tslots', body); if (old) old.remove();
      if (qty > 1) {
        var ol = document.createElement('ol'); ol.className = 'df-tslots';
        var h = ''; for (var i = 0; i < qty - 1; i++) h += slotHTML(slots[i], i);
        ol.innerHTML = h; body.appendChild(ol);
      }
      render();
    }
    function selectTier(q) {
      qty = q;
      tiers.forEach(function (t) { var on = Number(t.dataset.qty) === q; t.classList.toggle('is-on', on); var r = $('input[name^="df-tier-"]', t); if (r) r.checked = on; });
      drawSlots();
    }
    function pickDefaultSize(L) {
      var want = si >= 0 ? checked(si) : '';
      var hit = L.vs.filter(function (v) { return v.available && L.si > -1 && v.options[L.si] === want; })[0] || L.vs.filter(function (v) { return v.available; })[0] || L.vs[0];
      return hit ? (L.si > -1 ? hit.options[L.si] : String(hit.id)) : '';
    }
    function fillSlot(i, pc) {
      var mainColour = ci >= 0 ? checked(ci) : '';
      var colour = pc.colours.indexOf(mainColour) > -1 ? mainColour : (pc.colours[0] || null);  // same colour = matching set
      var L = pieceListing(pc, colour);
      slots[i] = { pc: pc, colour: colour, size: pickDefaultSize(L) };
      drawSlots();
    }
    function listHTML(q) {
      q = (q || '').toLowerCase().trim();
      var items = pieces.filter(function (pc) { return !q || (pc.title + ' ' + pc.type).toLowerCase().indexOf(q) > -1; });
      if (!items.length) return '<p class="df-small df-muted">' + esc(DF.strings.noResults) + '</p>';
      return items.map(function (pc) {
        var price = pc.min === pc.max ? '<span>' + money(pc.min) + '</span>' : '<span>' + money(pc.min) + '</span> – <span>' + money(pc.max) + '</span>';
        return '<div class="df-tpick"><span class="df-tpick__img df-media">' + (pc.image ? '<img src="' + pc.image + '" alt="" width="120" height="150" loading="lazy">' : '') + '</span>' +
          '<span class="df-tpick__body"><span class="df-tpick__name">' + esc(pc.title) + '</span><span class="df-tpick__price">' + price + '</span>' +
          (pc.colours.length > 1 ? '<span class="df-tpick__dots" aria-hidden="true">' + pc.colours.slice(0, 6).map(function (c) { return '<span class="df-swatch" style="--sw:' + hexFor(c) + '"></span>'; }).join('') + '</span>' : '') + '</span>' +
          '<button type="button" class="df-btn df-btn--dark df-tpick__btn" data-tpick="' + esc(pc.key) + '">' + esc(DF.strings.tierChoose) + '</button></div>';
      }).join('');
    }
    function openPicker(i) {
      pickFor = i; picker.showModal(); document.documentElement.classList.add('df-noscroll');
      if (pieces) { plist.innerHTML = listHTML(pq.value); return; }
      loadCatalogue().then(function (all) { pieces = groupPieces(all); plist.innerHTML = listHTML(pq.value); });
    }
    picker.addEventListener('close', function () { document.documentElement.classList.remove('df-noscroll'); });
    picker.addEventListener('click', function (e) {
      if (e.target === picker || e.target.closest('[data-tpicker-close]')) { picker.close(); return; }
      var b = e.target.closest('[data-tpick]'); if (!b || pickFor < 0) return;
      var pc = pieces.filter(function (x) { return x.key === b.dataset.tpick; })[0];
      if (pc) { fillSlot(pickFor, pc); picker.close(); var el = $$('.df-tslot', root)[pickFor]; if (el) el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'nearest' }); }
    });
    var tq; pq.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(function () { if (pieces) plist.innerHTML = listHTML(pq.value); }, 150); });

    root.addEventListener('click', function (e) { var c = e.target.closest('[data-tchoose]'); if (c) { e.preventDefault(); openPicker(Number(c.dataset.tchoose)); } });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-opt')) return;                          // this piece's colour / size: let it reach the form (gallery, stock, notify)
      e.stopPropagation();
      if (t.name && t.name.indexOf('df-tier-') === 0) { selectTier(Number(t.value)); return; }
      if (t.hasAttribute('data-tslot-colour')) { var i = Number(t.dataset.tslotColour); slots[i].colour = t.value; slots[i].size = pickDefaultSize(pieceListing(slots[i].pc, t.value)); drawSlots(); return; }
      if (t.hasAttribute('data-tslot-size')) { var k = Number(t.dataset.tslotSize); slots[k].size = t.value; drawSlots(); }
    });
    form.addEventListener('change', function () { setTimeout(syncMain, 0); });

    // Called by the product form on Add to bag / Buy now
    form._tierItems = function () {
      if (qty === 1) return null;
      var mv = $('input[name="id"]', form).value, ids = [mv];
      for (var i = 0; i < qty - 1; i++) {
        var v = slotVariant(slots[i]);
        if (!v || !v.available) { toast(DF.strings.tierNeedMore); openPicker(i); return false; }
        ids.push(v.id);
      }
      return ids;
    };
    syncMain();
    selectTier(1);
  }

  /* Ghost page buttons: "Go ghost" / "Make the switch" scroll to the buy box, "Get the duo" also selects that bundle,
     colour tiles pick that colour, and the lookbook's "Swipe" button moves one card (back to the start at the end) */
  /* Product page: one real review from the page's own reviews section, shown under the buy buttons */
  function initBuyQuote() {
    var box = $('[data-buyquote]'); if (!box) return;
    var card = $$('#df-reviews .df-testi__card').filter(function (c) { return !c.classList.contains('is-sample'); })[0]; if (!card) return;
    var q = $('.df-testi__quote', card), nameEl = $('.df-testi__name', card), stars = $('.df-stars', card), ver = $('.df-testi__ver', card), detail = $('.df-testi__detail', card);
    if (!q || !nameEl) return;
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    var text = q.textContent.replace(/\s+/g, ' ').trim();
    if (text.length > 170) text = text.slice(0, text.lastIndexOf(' ', 165)) + '…';
    var name = (nameEl.firstChild && nameEl.firstChild.nodeType === 3 ? nameEl.firstChild.textContent : nameEl.textContent).trim();
    box.innerHTML = (stars ? stars.outerHTML : '') + '<blockquote class="df-buyquote__q">“' + esc(text) + '”</blockquote>' +
      '<figcaption class="df-buyquote__who"><span class="df-buyquote__name">' + esc(name) + '</span>' + (ver ? ver.outerHTML : '') +
      (detail ? '<span class="df-buyquote__detail">' + esc(detail.textContent.trim()) + '</span>' : '') +
      '<a class="df-buyquote__all" href="#df-reviews">' + esc(DF.strings.allReviews) + '</a></figcaption>';
    box.hidden = false;
  }

  /* Product page: the rating line under the title shows this product's own reviews (average + count) when the page's
     reviews section holds reviews of it; otherwise it keeps the store-wide summary from Theme settings */
  function initRatingSync() {
    var line = $('.df-rating--line[data-rating-source="store"]'); if (!line) return;
    var cards = $$('#df-reviews .df-testi__card[data-mine][data-rating]').filter(function (c) { return !c.classList.contains('is-sample'); });
    if (!cards.length) return;
    var sum = cards.reduce(function (a, c) { return a + Number(c.dataset.rating); }, 0), avg = sum / cards.length, shown = (Math.round(avg * 10) / 10).toFixed(1);
    var stars = $('.df-stars', line), strong = $('.df-rating__txt strong', line), count = $('.df-rating__count', line), txt = $('.df-rating__txt', line);
    if (stars) stars.style.setProperty('--pct', (avg * 20) + '%');
    var label = avg >= 4.5 ? DF.strings.ratingExcellent : avg >= 4 ? DF.strings.ratingGreat : avg >= 3 ? DF.strings.ratingGood : '';
    if (txt) txt.innerHTML = (label ? label + ' ' : '') + '<strong>' + shown + '</strong>';
    if (count) count.textContent = DF.strings.reviewsN.replace('__N__', cards.length);
    line.setAttribute('aria-label', shown + ' / 5 — ' + DF.strings.reviewsN.replace('__N__', cards.length));
    line.removeAttribute('data-rating-source');
  }

  function initGhostActions() {
    document.addEventListener('click', function (e) {
      var go = e.target.closest('[data-gx-buy]');
      if (go) {
        e.preventDefault();
        var tierHead = go.dataset.gxTier ? $('[data-tier][data-qty="' + go.dataset.gxTier + '"] .df-tier__head') : null;
        if (tierHead && !tierHead.closest('.df-tier').classList.contains('is-on')) tierHead.click();
        var colour = go.dataset.gxColour, input = colour ? $$('input[data-opt]').filter(function (i) { return i.value === colour; })[0] : null;
        if (input && !input.checked) input.click();
        var target = (tierHead && tierHead.closest('.df-tier')) || (input && input.closest('fieldset')) || $('[data-tiers]') || $('[data-buy-box]') || $('h1');
        if (!target) return;
        var header = $('.df-header'), offset = (header ? header.getBoundingClientRect().height : 0) + 16;
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: RM ? 'auto' : 'smooth' });
        return;
      }
      var nav = e.target.closest('[data-gx-rail]');
      if (nav) {
        var rail = nav.closest('section') && nav.closest('section').querySelector('.gx-rl__rail'); if (!rail) return;
        var card = rail.querySelector('.gx-rl__card'), step = card ? card.getBoundingClientRect().width + 10 : rail.clientWidth * 0.8;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + step * Number(nav.dataset.gxRail || 1), behavior: RM ? 'auto' : 'smooth' });
      }
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-cart]'); if (t && drawerEl()) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-quick-add]'); if (q) { e.preventDefault(); if (!q.disabled) addToCart(q.dataset.quickAdd, 1, q); return; }
      var ch = e.target.closest('[data-line-change]');
      if (ch) {
        e.preventDefault();
        ch.disabled = true;
        cartPost(DF.routes.cart_change, { line: Number(ch.dataset.line), quantity: Math.max(0, Number(ch.dataset.lineChange)) })
          .then(function (j) { renderDrawer(j.sections && j.sections['cart-drawer']); setCount(j.item_count); })
          .catch(function (err) { ch.disabled = false; toast((err && (err.description || err.message)) || DF.strings.error); });
      }
    });
    document.addEventListener('keydown', function (e) {
      var d = drawerEl();
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeDrawer(); else trapTab(e, d);
    });
  }

  /* Product form: variant resolution, price, URL, colour-filtered gallery, size guard, qty, buy now, lightbox */
  function initProduct() {
    var form = $('[data-product-form]'); if (!form) return;
    var data = JSON.parse($('[data-product-json]').textContent);
    var idInput = $('input[name="id"]', form), qtyInput = $('input[name="quantity"]', form);
    var priceEls = $$('[data-price]'), addBtns = $$('[data-add-label]'), buyNow = $('[data-buy-now]', form);
    var colourIdx = Number(form.dataset.colourIndex), sizeIdx = Number(form.dataset.sizeIndex);
    var sizeGroup = $('[data-size-group]', form), sizeMsg = $('[data-size-msg]', form), sizeMsgDefault = sizeMsg ? (sizeMsg.dataset.default || '') : '';
    var gallery = $('[data-gallery]'), items = $$('[data-media-alt]'), dots = $('[data-gallery-dots]');
    var notifyBox = $('[data-notify]'), etaLi = $('[data-eta]');

    function selected() {
      return data.options.map(function (_, i) { var c = $('input[data-opt="' + i + '"]:checked', form); return c ? c.value : null; });
    }
    function findVariant(sel) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0];
    }
    function layoutGallery() {
      var vis = items.filter(function (i) { return !i.hidden; });
      items.forEach(function (i) { i.classList.remove('is-full'); });
      if (vis.length % 2 === 1 && vis[0]) vis[0].classList.add('is-full');
      if (dots) {
        dots.innerHTML = vis.length > 1 ? vis.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-on"' : '') + '></span>'; }).join('') : '';
      }
      if (gallery) gallery.scrollLeft = 0;
    }
    function filterMedia(colour) {
      if (!items.length) return;
      // Media alt text must start with the colour name, e.g. "Black — zipped". No match at all → show every photo.
      var c = (colour || '').toLowerCase().trim();
      var matches = c ? items.filter(function (m) { return m.dataset.mediaAlt.indexOf(c) === 0; }) : [];
      items.forEach(function (m) { m.hidden = matches.length > 0 && matches.indexOf(m) === -1; });
      if (!matches.length && gallery) {
        // No colour alt text: bring the chosen colour's variant image (if any) to the front
        var v = data.variants.filter(function (x) { return x.options[colourIdx] === colour && x.media_id; })[0];
        var el = v && $('[data-media-id="' + v.media_id + '"]', gallery);
        if (el && el !== gallery.firstElementChild) { gallery.insertBefore(el, gallery.firstElementChild); items = $$('[data-media-alt]', gallery); }
      }
      layoutGallery();
    }
    function update(fromUser) {
      var sel = selected();
      var colour = colourIdx >= 0 ? sel[colourIdx] : null;
      // disable sizes that are unavailable for the chosen colour
      if (sizeIdx >= 0) {
        $$('input[data-opt="' + sizeIdx + '"]', form).forEach(function (inp) {
          var match = function (v) { return v.options[sizeIdx] === inp.value && (colourIdx < 0 || v.options[colourIdx] === colour); };
          var exists = data.variants.some(match), avail = data.variants.some(function (v) { return v.available && match(v); });
          // With "Notify me" on, sold-out sizes stay selectable (struck through) so shoppers can ask for a restock alert
          inp.disabled = notifyBox ? !exists : !avail;
          inp.parentNode.classList.toggle('is-oos', !!notifyBox && exists && !avail);
          if (notifyBox && exists && !avail) inp.setAttribute('aria-label', inp.value + ', ' + DF.strings.soldOut); else inp.removeAttribute('aria-label');
          if (inp.disabled && inp.checked) inp.checked = false;
        });
        sel = selected();
      }
      if (colourIdx >= 0) {
        $$('[data-colour-label]').forEach(function (n) { n.textContent = colour || ''; });
        $$('.df-colour-tile').forEach(function (t) { var i = $('input', t); t.classList.toggle('is-checked', !!(i && i.checked)); });
        if (fromUser !== 'size') filterMedia(colour);
      }
      var size = sizeIdx >= 0 ? sel[sizeIdx] : 'n/a';
      $$('[data-size-label]').forEach(function (n) { n.textContent = sizeIdx >= 0 ? (size || '') : ''; });
      $$('[data-sticky-size]').forEach(function (n) { n.textContent = sizeIdx >= 0 && size ? ' · ' + size : ''; });
      if (size && sizeGroup) { sizeGroup.classList.remove('is-error'); if (sizeMsg) sizeMsg.textContent = sizeMsgDefault; }

      var v = findVariant(sel);
      if (!v && colourIdx >= 0) v = data.variants.filter(function (x) { return x.options[colourIdx] === colour; })[0];
      if (v) {
        if (size) idInput.value = v.id;
        priceEls.forEach(function (p) { p.innerHTML = v.price_formatted; });
        if (fromUser && size) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(history.state, '', url); }
      }
      var full = size ? findVariant(sel) : null;
      var soldOut = !!(full && !full.available);
      addBtns.forEach(function (b) { b.textContent = !size ? DF.strings.selectSize : (soldOut ? DF.strings.soldOut : DF.strings.addBag); b.disabled = soldOut; });
      if (buyNow) buyNow.disabled = soldOut;
      var avail = $('[data-avail-text]'), dot = $('[data-avail] .df-dot');
      var anyAvail = data.variants.some(function (x) { return x.available && (colourIdx < 0 || x.options[colourIdx] === colour); });
      var isAvail = full ? full.available : anyAvail;
      if (avail) avail.textContent = isAvail ? avail.dataset.on || avail.textContent : DF.strings.soldOut;
      if (dot) dot.classList.toggle('df-dot--off', !isAvail);
      var out = soldOut || !anyAvail;
      if (etaLi) etaLi.hidden = out;
      if (notifyBox) {
        notifyBox.hidden = !out;
        var what = full ? full.title : (colour || '');
        var tags = $('[data-notify-tags]', notifyBox);
        // Shopify tags: no commas, max 255 characters
        if (tags) tags.value = 'restock, ' + ('restock: ' + notifyBox.dataset.title + ' / ' + what).replace(/,/g, ' ').slice(0, 250);
      }
    }
    var availText = $('[data-avail-text]'); if (availText) availText.dataset.on = availText.textContent;

    form.addEventListener('change', function (e) {
      var opt = e.target && e.target.dataset ? Number(e.target.dataset.opt) : -1;
      update(opt === sizeIdx ? 'size' : 'colour');
    });
    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(10, (Number(qtyInput.value) || 1) + Number(b.dataset.qtyStep))); });
    });
    qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, Math.min(10, Math.round(Number(qtyInput.value)) || 1)); });

    function needSize() {
      if (sizeIdx < 0 || selected()[sizeIdx]) return false;
      if (sizeGroup) {
        sizeGroup.classList.add('is-error');
        if (sizeMsg) sizeMsg.textContent = DF.strings.chooseSize;
        sizeGroup.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
        var first = $('input[data-opt="' + sizeIdx + '"]:not(:disabled)', form); if (first) first.focus({ preventScroll: true });
      }
      return true;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (needSize()) return;
      var v = findVariant(selected()); if (v) idInput.value = v.id;
      var qty = Math.max(1, Math.min(10, Number(qtyInput.value) || 1));
      // Bundle tiers: a multi-piece tier adds the whole set (null = single piece, false = set not complete yet)
      var set = form._tierItems ? form._tierItems() : null;
      if (set === false) return;
      if (set && set.length > 1) {
        if (e.submitter && e.submitter.hasAttribute('data-buy-now')) {
          window.location.href = (DF.routes.root || '/').replace(/\/$/, '') + '/cart/' + set.map(function (id) { return id + ':1'; }).join(',');
          return;
        }
        addItems(set.map(function (id) { return { id: Number(id), quantity: 1 }; }), e.submitter || null);
        return;
      }
      if (e.submitter && e.submitter.hasAttribute('data-buy-now')) {
        window.location.href = (DF.routes.root || '/').replace(/\/$/, '') + '/cart/' + idInput.value + ':' + qty;
        return;
      }
      addToCart(idInput.value, qty, e.submitter || null);
    });
    $$('[data-sticky-add]').forEach(function (b) { b.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }); });
    $$('[data-open-dialog]').forEach(function (b) { b.addEventListener('click', function () { var d = document.getElementById(b.dataset.openDialog); if (d && d.showModal) d.showModal(); }); });

    // Mobile carousel dots follow the scroll position
    if (gallery && dots) {
      gallery.addEventListener('scroll', function () {
        var vis = items.filter(function (i) { return !i.hidden; }); if (!vis.length) return;
        var idx = Math.round(Math.abs(gallery.scrollLeft) / gallery.clientWidth);
        $$('span', dots).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      }, { passive: true });
    }
    update(false);
    layoutGallery();

    // Sticky add-to-bag: visible once the main buy box has scrolled out of view (above the viewport)
    var sticky = $('[data-sticky-atc]'), buyBox = $('[data-buy-box]', form);
    if (sticky && buyBox) {
      var stickyBtn = $('[data-sticky-add]', sticky), shown = null;
      onScroll(function () {
        var show = buyBox.getBoundingClientRect().bottom < 0;
        if (show === shown) return; shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      });
    }

    // Remember this product for "Recently viewed"
    try {
      var rv = JSON.parse(localStorage.getItem('df-recent')) || [];
      rv = [data.handle].concat(rv.filter(function (h) { return h !== data.handle; })).slice(0, 12);
      localStorage.setItem('df-recent', JSON.stringify(rv));
    } catch (err) { /* storage blocked */ }

    // Lightbox: full-screen, prev/next, n / N, Esc, arrow keys (reversed in RTL)
    var lb = $('[data-lightbox]'); if (!lb) return;
    var idx = 0, img = $('[data-lb-img]', lb), counter = $('[data-lb-counter]', lb), opener = null;
    function visible() { return items.filter(function (i) { return !i.hidden; }); }
    function show(i) {
      var v = visible(); if (!v.length) return;
      idx = (i + v.length) % v.length;
      img.src = v[idx].dataset.zoom; img.alt = v[idx].dataset.alt || '';
      counter.textContent = (idx + 1) + ' / ' + v.length;
    }
    function open(i) { opener = document.activeElement; show(i); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; $('[data-lb-close]', lb).focus(); }
    function close() { lb.hidden = true; document.documentElement.style.overflow = ''; if (opener) opener.focus({ preventScroll: true }); }
    items.forEach(function (b) { b.addEventListener('click', function () { open(visible().indexOf(b)); }); });
    $('[data-lb-close]', lb).addEventListener('click', close);
    $('[data-lb-prev]', lb).addEventListener('click', function () { show(idx - 1); });
    $('[data-lb-next]', lb).addEventListener('click', function () { show(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + (DF.rtl ? -1 : 1));
      else if (e.key === 'ArrowLeft') show(idx + (DF.rtl ? 1 : -1));
      else trapTab(e, lb);
    });
  }

  /* Size guide: cm ⇄ in, highlight the selected size, "Find my size" from body-measurement ranges */
  function initSizeGuides() {
    $$('[data-size-guide]').forEach(function (g) {
      // The chart shows cm and in side by side; the unit switch only sets the unit of the "Find my size" inputs.
      var unit = 'cm', table = $('[data-size-table]', g);
      function setUnit(u) {
        unit = u;
        $$('[data-unit]', g).forEach(function (b) { var on = b.dataset.unit === u; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $$('[data-unit-label]', g).forEach(function (l) { l.textContent = u; });
      }
      $$('[data-unit]', g).forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.unit); }); });

      var finder = $('[data-size-finder]', g);
      if (finder && table) {
        $('[data-find-btn]', finder).addEventListener('click', function () {
          var out = $('[data-find-result]', finder), want = [];
          $$('[data-find-col]', finder).forEach(function (inp) {
            var v = parseFloat(inp.value); if (!isNaN(v) && v > 0) want.push({ col: Number(inp.dataset.findCol), cm: unit === 'in' ? v * 2.54 : v });
          });
          if (!want.length) { out.hidden = true; return; }
          var match = null;
          $$('tbody tr', table).some(function (tr) {
            var ok = want.every(function (w) {
              var cell = $('td[data-col="' + w.col + '"]', tr);
              var raw = (cell && cell.dataset.cm) || '';
              var nums = raw.match(/\d+(\.\d+)?/g); if (!nums) return true;
              var lo = Number(nums[0]), hi = Number(nums[nums.length - 1]);
              return w.cm >= lo - 0.5 && w.cm <= hi + 0.5;
            });
            if (ok) match = tr.dataset.size;
            return ok;
          });
          out.hidden = false;
          if (!match) { out.textContent = DF.strings.sgNone; return; }
          out.innerHTML = '';
          var p = document.createElement('strong'); p.textContent = DF.strings.sgRec.replace('__S__', match); out.appendChild(p);
          var radio = $$('[data-size-group] input[type=radio]').filter(function (r) { return r.value === match && !r.disabled; })[0];
          if (radio) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'df-btn df-btn--outline';
            b.textContent = DF.strings.sgSelect.replace('__S__', match);
            b.addEventListener('click', function () {
              radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true }));
              var d = g.closest('dialog'); if (d && d.close) d.close();
            });
            out.appendChild(b);
          }
          $$('tbody tr', table).forEach(function (tr) { tr.classList.toggle('is-rec', tr.dataset.size === match); });
        });
      }
    });
    // highlight the size currently chosen on the product page
    function mark() {
      var r = $('[data-size-group] input[type=radio]:checked');
      $$('[data-size-table] tbody tr').forEach(function (tr) { tr.classList.toggle('is-current', !!r && tr.dataset.size === r.value); });
    }
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-size-group]')) mark(); });
    mark();
  }


  /* Money: Shopify money format with {{amount}}-style placeholders */
  function money(cents) {
    var fmt = (DF.showCode ? DF.moneyCode : DF.money) || '{{amount}}';
    var v = (Number(cents) || 0) / 100;
    function grp(n, d, t, s) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(d ? s : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return grp(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(v, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return grp(v, 2, "'", '.');
      return grp(v, 2, ',', '.');
    }).replace(/<[^>]+>/g, '');
  }

  /* Buy 2, get 1 free set builder: slot 1 = this piece, slots 2+ = any product/colour/size the shopper picks */
  var COLOUR_RE = /^(colou?r|farbe|couleur|colore|cor|kleur)$/i, SIZE_RE = /^(size|taille|größe|grösse|talla|taglia|tamanho|maat)$/i;
  var catalogue = null;
  function loadCatalogue() {
    if (catalogue) return catalogue;
    catalogue = fetch(base() + '/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
      return (j.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }); }).map(function (p) {
        var img = p.images && p.images[0] ? p.images[0].src : '';
        return { handle: p.handle, title: p.title, url: '/products/' + p.handle, type: p.product_type || '',
          image: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '',
          images: (p.images || []).map(function (im) { return { src: im.src + (im.src.indexOf('?') > -1 ? '&' : '?') + 'width=240', ids: im.variant_ids || [] }; }),
          options: p.options.map(function (o) { return o.name; }),
          variants: p.variants.map(function (v) { return { id: v.id, options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }), price: Math.round(parseFloat(v.price) * 100), available: v.available }; }) };
      });
    }).catch(function () { catalogue = null; return []; });
    return catalogue;
  }
  function cleanTitle(t) {
    var x = String(t || '');
    x = x.replace(/\s*(\||–|-)\s*(black|white|brown|green|gr[ae]y|beige|pink|purple|red|winred|wine red|oliver green|olive green|sniky black|rose gold|navy|blue|dk|man|men|women|copy)\s*$/i, '');
    return x.toLowerCase().replace(/\bjacke\b/g, 'jacket').replace(/(^|[\s(])([a-z])/g, function (m, a, c) { return a + c.toUpperCase(); });
  }
  function initBundle() {
    $$('[data-bundle]').forEach(function (b) {
      var form = b.closest('form') || $('form[data-product-form]') || document;
      var mainItem = $('[data-main]', b);
      var mainPrices = {}; try { mainPrices = JSON.parse($('[data-bmain-prices]', b).textContent); } catch (e) { /* none */ }
      var qty = Number(b.dataset.offerQty) || 0, btn = $('[data-badd]', b), pickFor = null;
      var picker = $('[data-bpicker]', b), grid = $('[data-bpicker-grid]', b), search = $('[data-bpicker-search]', b);
      function mainId() { var i = $('input[name="id"]', form); return i && i.value ? i.value : null; }
      function sizeLabel() { var r = $('[data-size-group] input[type=radio]:checked', form); return r ? r.value : ''; }
      function opt(sel, values, current) {
        sel.innerHTML = ''; values.forEach(function (v) { var o = document.createElement('option'); o.value = v.value; o.textContent = v.label; if (v.disabled) o.disabled = true; if (v.value === current) o.selected = true; sel.appendChild(o); });
        sel.hidden = values.length < 2 && !(values[0] && values[0].label);
      }
      // Fill a slot with a product: colour select + size select built from its variants
      function setSlot(slot, p, wantColour) {
        slot._p = p;
        var ci = p.options.findIndex(function (n) { return COLOUR_RE.test(n); }), si = p.options.findIndex(function (n) { return SIZE_RE.test(n); });
        slot._ci = ci; slot._si = si;
        $('[data-bname]', slot).textContent = cleanTitle(p.title);
        var im = $('[data-bimg]', slot); if (p.image) im.innerHTML = '<img src="' + p.image + '" alt="" loading="lazy" width="64" height="80">';
        var colours = [];
        if (ci > -1) p.variants.forEach(function (v) { var c = v.options[ci]; if (colours.indexOf(c) === -1) colours.push(c); });
        var cur = colours.filter(function (c) { return wantColour && c.toLowerCase() === String(wantColour).toLowerCase(); })[0];
        if (!cur) cur = colours.filter(function (c) { return p.variants.some(function (v) { return v.options[ci] === c && v.available; }); })[0] || colours[0];
        var cs = $('[data-bcolour]', slot);
        opt(cs, colours.map(function (c) { return { value: c, label: c, disabled: !p.variants.some(function (v) { return v.options[ci] === c && v.available; }) }; }), cur);
        cs.hidden = ci < 0;
        fillSizes(slot);
        slot.classList.add('is-set');
      }
      function fillSizes(slot) {
        var p = slot._p, ci = slot._ci, si = slot._si, colour = $('[data-bcolour]', slot).value, prev = $('[data-bsize]', slot).value;
        var vs = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === colour; });
        var first = vs.filter(function (v) { return v.available; })[0] || vs[0];
        var keep = vs.filter(function (v) { return String(v.id) === prev && v.available; })[0];
        opt($('[data-bsize]', slot), vs.map(function (v) { return { value: String(v.id), label: si > -1 ? v.options[si] : (v.options.join(' / ') || '—') , disabled: !v.available }; }), String((keep || first).id));
      }
      function slotVariant(slot) {
        if (!slot._p) return null; var id = $('[data-bsize]', slot).value;
        return slot._p.variants.filter(function (v) { return String(v.id) === id; })[0] || null;
      }
      function update() {
        var prices = [];
        var mp = mainPrices[mainId()];
        if (mp != null) { $('[data-bprice]', mainItem).textContent = money(mp); prices.push(mp); }
        var sl = sizeLabel(); $('[data-bmain-size]', mainItem).textContent = sl ? sl : DF.strings.needSize;
        $$('[data-slot]', b).forEach(function (slot) {
          var v = slotVariant(slot); $('[data-bprice]', slot).textContent = v ? money(v.price) : '';
          if (v) prices.push(v.price);
        });
        var total = prices.reduce(function (a, c) { return a + c; }, 0), save = 0;
        if (qty > 1 && prices.length >= qty) {
          var sorted = prices.slice().sort(function (a, c) { return a - c; }), free = Math.floor(prices.length / qty);
          for (var i = 0; i < free; i++) save += sorted[i];
        }
        $('[data-btotal]', b).textContent = money(total - save);
        var was = $('[data-bwas]', b); was.hidden = !save; was.textContent = save ? money(total) : '';
        var note = $('[data-bnote]', b); note.hidden = !save; note.textContent = save ? DF.strings.bundleSave.replace('__X__', money(save)) : '';
        btn.textContent = btn.dataset.labelN.replace('__N__', prices.length);
      }
      function renderGrid(q) {
        loadCatalogue().then(function (list) {
          q = (q || '').toLowerCase().trim();
          var items = list.filter(function (p) { return !q || p.title.toLowerCase().indexOf(q) > -1; }).slice(0, 40);
          grid.innerHTML = '';
          if (!items.length) { grid.textContent = DF.strings.noResults; return; }
          items.forEach(function (p) {
            var minP = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
            var el = document.createElement('button'); el.type = 'button'; el.className = 'df-bpick';
            el.innerHTML = '<span class="df-bpick__img">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="120" height="150">' : '') + '</span><span class="df-bpick__name"></span><span class="df-bpick__price">' + money(minP) + '</span>';
            $('.df-bpick__name', el).textContent = cleanTitle(p.title);
            el.addEventListener('click', function () {
              if (!pickFor) return;
              setSlot(pickFor, p, b.dataset.colour); update();
              picker.hidden = true; var s = pickFor; pickFor = null; s.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); $('[data-bsize]', s).focus();
            });
            grid.appendChild(el);
          });
        });
      }
      // initial slots from Liquid JSON
      $$('[data-slot]', b).forEach(function (slot) {
        var j = $('[data-bproduct]', slot);
        if (j) { try { var p = JSON.parse(j.textContent); setSlot(slot, p, p.colour); } catch (e) { /* skip */ } }
        $('[data-bchange]', slot).addEventListener('click', function () {
          pickFor = slot; picker.hidden = false; $('[data-bpicker-title]', b).textContent = DF.strings.bundlePickN.replace('__N__', slot.dataset.slot * 1 + 1);
          renderGrid(search.value); picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); search.focus({ preventScroll: true });
        });
        $('[data-bcolour]', slot).addEventListener('change', function () { fillSizes(slot); update(); });
        $('[data-bsize]', slot).addEventListener('change', update);
      });
      $('[data-bpicker-close]', b).addEventListener('click', function () { picker.hidden = true; pickFor = null; });
      var t; search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { renderGrid(search.value); }, 150); });
      b.addEventListener('change', function (e) { e.stopPropagation(); });
      form.addEventListener('change', function () { setTimeout(update, 0); });
      btn.addEventListener('click', function () {
        var id = mainId();
        if (!id || !sizeLabel() && $('[data-size-group]', form)) {
          toast(DF.strings.needSize);
          var g = $('[data-size-group]', form); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var items = [{ id: Number(id), quantity: 1 }];
        $$('[data-slot]', b).forEach(function (slot) { var v = slotVariant(slot); if (v) items.push({ id: Number(v.id), quantity: 1 }); });
        btn.disabled = true; var label = btn.textContent; btn.textContent = DF.strings.adding;
        cartPost(DF.routes.cart_add, { items: items })
          .then(function (j) { renderDrawer(j.sections && j.sections['cart-drawer']); return refreshCount(); })
          .then(function () { openDrawer(); })
          .catch(function (e) { toast((e && (e.description || e.message)) || DF.strings.error); })
          .then(function () { btn.disabled = false; btn.textContent = label; });
      });
      update();
    });
  }

  /* "Worn by you" videos: load and play only while on screen (nothing downloads before that) */
  function initVideos() {
    var vids = $$('video[data-lazy-video]'); if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.preload = 'metadata'; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '120px 0px', threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  /* Wishlist: product handles in localStorage "df-wish" */
  var WKEY = 'df-wish';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ } }
  function paintHearts() {
    var list = wishGet();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? DF.strings.wishRemove : DF.strings.wishAdd);
      var s = $('span', b); if (s) s.textContent = on ? '♥' : '♡';
    });
  }
  function initWishlist() {
    paintHearts();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]'); if (!b) return;
      e.preventDefault();
      var list = wishGet(), h = b.dataset.wish, i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      wishSet(list); paintHearts();
      toast(i === -1 ? DF.strings.wishAdded : DF.strings.wishRemoved);
      if (i !== -1 && $('[data-wishlist]')) renderWishlist();
    });
    if ($('[data-wishlist]')) renderWishlist();
  }
  function base() { return (DF.routes.root || '/').replace(/\/$/, ''); }
  // Render product cards for a list of handles through the df-wish-card section (Section Rendering API)
  function cardsFor(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch(base() + '/products/' + encodeURIComponent(h) + '?section_id=df-wish-card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      return htmls.map(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        return $$('.df-card', tmp).map(function (c) { return c.outerHTML; }).join('');
      }).join('');
    });
  }
  function renderWishlist() {
    var grid = $('[data-wish-grid]'), empty = $('[data-wish-empty]'), list = wishGet();
    if (!grid) return;
    if (!list.length) { grid.innerHTML = ''; empty.hidden = false; return; }
    cardsFor(list).then(function (out) { grid.innerHTML = out; empty.hidden = !!out; paintHearts(); });
  }
  function initRecent() {
    var box = $('[data-recent]'); if (!box) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('df-recent')) || []; } catch (e) { return; }
    list = list.filter(function (h) { return h !== box.dataset.current; }).slice(0, 4);
    if (!list.length) return;
    cardsFor(list).then(function (out) { if (!out) return; $('[data-recent-grid]', box).innerHTML = out; box.hidden = false; paintHearts(); });
  }
  // "Complete the look": when no rule/metafield matched, ask Shopify Search & Discovery (complementary, then related)
  function initUpsell() {
    var sec = $('[data-upsell-section]'); if (!sec || sec.hasAttribute('data-filled') || !sec.dataset.productId) return;
    function load(intent) {
      var url = base() + '/recommendations/products?product_id=' + sec.dataset.productId + '&limit=' + (sec.dataset.limit || 4) + '&intent=' + intent + '&section_id=' + sec.dataset.sectionId;
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-upsell-section]', tmp);
        if (fresh && $('.df-card', fresh)) { sec.replaceWith(fresh); paintHearts(); return true; }
        return false;
      }).catch(function () { return false; });
    }
    load('complementary').then(function (ok) { if (!ok) load('related'); });
  }

  /* Client-side validation for the newsletter and contact forms (inline, translated messages) */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function initForms() {
    $$('form[data-df-validate]').forEach(function (f) {
      // capture phase on window: runs before Shopify's form tracking, which would otherwise submit invalid forms
      window.addEventListener('submit', function (e) { if (e.target !== f) return;
        var firstBad = null, msgBox = $('[data-form-msg]', f), msg = '';
        $$('input[required], textarea[required]', f).forEach(function (inp) {
          var bad = inp.type === 'checkbox' ? !inp.checked : (inp.type === 'email' ? !EMAIL.test(inp.value.trim()) : !inp.value.trim());
          inp.setAttribute('aria-invalid', bad ? 'true' : 'false');
          var err = inp.getAttribute('aria-describedby') && document.getElementById(inp.getAttribute('aria-describedby'));
          var text = inp.type === 'checkbox' ? DF.strings.needConsent : (inp.type === 'email' ? DF.strings.badEmail : DF.strings.required);
          if (err && err.hasAttribute('data-field-err')) err.textContent = bad ? text : '';
          if (bad && !msg) msg = text;
          if (bad && !firstBad) firstBad = inp;
        });
        if (msgBox) { msgBox.textContent = msg; msgBox.classList.toggle('is-err', !!msg); }
        if (firstBad) { e.preventDefault(); e.stopImmediatePropagation(); firstBad.focus(); }
      }, true);
    });
  }

  /* Consent via Shopify Customer Privacy API (banner + preferences page) */
  function withPrivacy(cb) {
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
    });
  }
  function initConsent() {
    var banner = $('[data-df-consent]'), prefs = $('[data-cookie-prefs]');
    if (!banner && !prefs) return;
    withPrivacy(function (cp) {
      if (banner && cp.shouldShowBanner && cp.shouldShowBanner() && !prefs) banner.hidden = false;
      $$('[data-consent]', banner || document).forEach(function (b) {
        b.addEventListener('click', function () {
          var yes = b.dataset.consent === 'accept';
          cp.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, function () { banner.hidden = true; });
        });
      });
      if (prefs) {
        var sw = { analytics: $('[data-ck="analytics"]', prefs), marketing: $('[data-ck="marketing"]', prefs) };
        if (cp.analyticsProcessingAllowed && sw.analytics) sw.analytics.setAttribute('aria-checked', cp.analyticsProcessingAllowed() ? 'true' : 'false');
        if (cp.marketingAllowed && sw.marketing) sw.marketing.setAttribute('aria-checked', cp.marketingAllowed() ? 'true' : 'false');
        $$('[data-ck]', prefs).forEach(function (s) {
          s.addEventListener('click', function () { s.setAttribute('aria-checked', s.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); });
        });
        var save = $('[data-ck-save]', prefs), out = $('[data-ck-msg]', prefs);
        if (save) save.addEventListener('click', function () {
          var a = sw.analytics && sw.analytics.getAttribute('aria-checked') === 'true';
          var m = sw.marketing && sw.marketing.getAttribute('aria-checked') === 'true';
          cp.setTrackingConsent({ analytics: a, marketing: m, preferences: true, sale_of_data: m }, function () {
            if (out) out.textContent = DF.strings.saved;
            if (banner) banner.hidden = true;
          });
        });
      }
    });
  }

  /* Localization selects and collection filters auto-submit */
  function initAutoSubmit() {
    $$('[data-localization-form] select, [data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { if (s.form) s.form.submit(); });
    });
  }

  /* Mobile menu */
  function initMenu() {
    var m = $('[data-menu]'); if (!m) return;
    var burger = $('[data-open-menu]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-menu]')) { openOverlay(m, '[data-close-menu]'); if (burger) burger.setAttribute('aria-expanded', 'true'); }
      else if (e.target.closest('[data-close-menu]')) { closeOverlay(m); if (burger) burger.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('keydown', function (e) {
      if (!m.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeOverlay(m); if (burger) burger.setAttribute('aria-expanded', 'false'); } else trapTab(e, m);
    });
  }

  /* Customer-form sign-ups (Notify me, welcome pop-up). Shopify refuses background posts to /contact, so after
     validation the form is submitted normally; Shopify returns to the page with ?customer_posted=true#<form id>. */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  function returnedFrom(id) {
    var posted = /[?&]customer_posted=true/.test(window.location.search) && window.location.hash === '#' + id;
    if (posted) { var u = new URL(window.location.href); u.searchParams.delete('customer_posted'); u.hash = ''; history.replaceState(history.state, '', u); }
    return posted;
  }
  function postSignup(form, btn) { if (btn) btn.disabled = true; HTMLFormElement.prototype.submit.call(form); }
  // Shopify's analytics script re-submits /contact forms even when a theme handler cancels the submit,
  // so these handlers run first (window, capture phase) and stop the event when they take over.
  function onSubmit(sel, fn) {
    window.addEventListener('submit', function (e) { var f = e.target; if (f && f.matches && f.matches(sel)) fn(e, f); }, true);
  }
  function takeOver(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  function emailOk(inp) { var ok = !!inp && EMAIL.test(inp.value.trim()); if (inp) inp.setAttribute('aria-invalid', ok ? 'false' : 'true'); return ok; }

  function initNotify() {
    var form = $('[data-notify-form]'), box = $('[data-notify]'); if (!form || !box) return;
    var msg = $('[data-notify-msg]', box), email = $('input[type="email"]', box), btn = $('button[type="submit"]', box);
    // The return trip drops the chosen size, so confirm with a toast
    if (returnedFrom('DfNotify')) toast(DF.strings.notifyOk);
    onSubmit('[data-notify-form]', function (e) {
      takeOver(e);
      if (!emailOk(email)) { msg.classList.add('is-err'); msg.textContent = DF.strings.badEmail; email.focus(); return; }
      postSignup(form, btn);
    });
  }

  function initEta() {
    var li = $('[data-eta]'); if (!li) return;
    function addBiz(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
    function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
    var now = new Date(), n = function (k) { return Number(li.dataset[k]) || 0; }, txt = '';
    if (n('tmax') > 0) txt = DF.strings.etaArrive.replace('__A__', fmt(addBiz(now, n('dmin') + n('tmin')))).replace('__B__', fmt(addBiz(now, n('dmax') + n('tmax'))));
    else if (n('dmax') > 0) txt = DF.strings.etaBy.replace('__D__', fmt(addBiz(now, n('dmax'))));
    var t = $('[data-eta-text]', li); if (t && txt) t.textContent = txt;
  }

  function initWelcome() {
    var dlg = $('[data-welcome]'); if (!dlg || !dlg.showModal) return;
    var KEY = 'df-welcome', form = $('[data-welcome-form]', dlg), msg = $('[data-welcome-msg]', dlg);
    var design = window.Shopify && Shopify.designMode;
    function showOk() { $('[data-welcome-step="form"]', dlg).hidden = true; $('[data-welcome-step="ok"]', dlg).hidden = false; lsSet(KEY, 'joined'); }
    function open() { if (!dlg.open && !document.querySelector('dialog[open]')) { dlg.showModal(); document.documentElement.classList.add('df-noscroll'); } }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('df-noscroll');
      if (lsGet(KEY) !== 'joined') lsSet(KEY, 'closed:' + Date.now());
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    $$('[data-welcome-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    var copy = $('[data-copy]', dlg);
    if (copy) copy.addEventListener('click', function () {
      var lbl = $('[data-copy-label]', copy);
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.copy).then(function () { if (lbl) lbl.textContent = copy.dataset.copied; }, function () {});
    });
    if (form) onSubmit('[data-welcome-form]', function (e) {
      takeOver(e);
      var email = $('input[type="email"]', form), consent = $('input[type="checkbox"]', form), btn = $('button[type="submit"]', form);
      if (!emailOk(email)) { msg.classList.add('is-err'); msg.textContent = DF.strings.badEmail; email.focus(); return; }
      if (consent && !consent.checked) { msg.classList.add('is-err'); msg.textContent = DF.strings.needConsent; consent.focus(); return; }
      postSignup(form, btn);
    });
    if (returnedFrom('DfWelcome')) { showOk(); open(); return; }
    var seen = lsGet(KEY) || '';
    if (!design && (seen === 'joined' || (seen.indexOf('closed:') === 0 && Date.now() - Number(seen.slice(7)) < 7 * 864e5))) return;
    // Wait until any cookie banner (Shopify's or ours) has been answered, so the two never stack
    function bannerUp() {
      return [$('#shopify-pc__banner'), $('[data-df-consent]')].some(function (el) { return el && !el.hidden && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; });
    }
    // ...and never interrupt someone in the bag or the menu
    function busy() { return !!document.querySelector('[data-cart-drawer].is-open, [data-menu].is-open'); }
    function tryOpen() { if (bannerUp() || busy()) setTimeout(tryOpen, 3000); else open(); }
    setTimeout(tryOpen, (Number(dlg.dataset.delay) || 10) * 1000);
  }

  function init() {
    initHeader(); initHero(); initSpecs(); initManifesto(); initCart(); initProduct();
    initWishlist(); initRecent(); initUpsell(); initBundle(); initVideos(); initSizeGuides(); initForms(); initConsent(); initAutoSubmit(); initMenu(); initNotify(); initEta(); initWelcome(); initDrawerBrowse(); initTiers(); initGhostActions(); initBuyQuote(); initRatingSync();
  }
  /* Theme editor: re-run the scroll/visual behaviours when a section is re-rendered */
  document.addEventListener('shopify:section:load', function () { initHero(); initSpecs(); initManifesto(); paintHearts(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
